import { Link } from 'react-router-dom'
import { Seo } from '@/components/seo'
import { PageLayout } from '@/components/layout/page-layout'
import { useI18n } from '@/lib/i18n'

export default function NotFoundPage() {
  const { t, path } = useI18n()

  return (
    <PageLayout>
      <Seo title={t('seo404Title')} description={t('seo404Desc')} />
      <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4">
        <p className="text-6xl font-bold text-primary">404</p>
        <p className="text-muted-foreground">{t('nfBody')}</p>
        <Link to={path('/')} className="text-sm font-medium text-primary hover:underline">
          {t('commonBackHome')}
        </Link>
      </div>
    </PageLayout>
  )
}